import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Edit as EditIcon } from '@mui/icons-material'
import BasicDataGrid from 'components/generic/datagrid'

const useStyles = makeStyles(theme => ({
  root: {
    // remove header padding to align headers with column values
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: theme.spacing(0),
    },
    '& .MuiDataGrid-columnHeader': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-cell': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    '& .MuiDataGrid-columnSeparator': {
      visibility: 'hidden',
    },
  },
}))

const SettingsColumnEdit = ({ title, subTitle, subTitle2, generateColumns, rows, dataGridProps }) => {
  const classes = useStyles()
  const columns = generateColumns()

  return (
    <>
      <Typography variant="h6" color="textPrimary">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        {subTitle}
      </Typography>
      {subTitle2 && (
        <Typography variant="body2" color="textSecondary">
          {subTitle2}
        </Typography>
      )}
      <Box mt={1}>
        <Button startIcon={<EditIcon />} onClick={() => {}}>
          Edit Columns
        </Button>
      </Box>
      <Box mt={1}>
        <BasicDataGrid
          className={classes.root}
          density="compact"
          height="auto"
          rows={rows}
          columns={columns}
          editMode="row"
          disableColumnMenu
          hideFooter
          {...dataGridProps}
        />
      </Box>
    </>
  )
}

SettingsColumnEdit.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  subTitle2: PropTypes.string,
  generateColumns: PropTypes.func,
  rows: PropTypes.array,
  dataGridProps: PropTypes.object,
}

SettingsColumnEdit.defaultProps = {
  subTitle2: '',
  generateColumns: () => [],
  rows: [],
  dataGridProps: {},
}

export default SettingsColumnEdit
